import React from 'react'
import { useTranslation } from 'react-i18next'

import { Header } from 'src/components'
import { useChangeBackground } from 'src/hooks/useChangeBackground'

import styles from './TransactionPage.module.scss'
import { TransactionDetail, TransactionInfo } from './components'
import { useGetUserTransaction } from './hooks/useGetUserTransaction'

const TransactionPage = () => {
  useChangeBackground(styles.background)
  const { userTransaction } = useGetUserTransaction()

  const { t } = useTranslation()

  const {
    type: transactionType,
    amount_stars,
    commission,
    created_at,
    ToUser,
    FromUser,
    Withdrawal,
  } = userTransaction ?? {}

  return (
    <>
      <Header
        variant='settings'
        setting={t(`transactions_page.${transactionType}`)}
        color='black'
        path='/transactions'
      />

      <main className={styles.transaction}>
        <div>
          <TransactionInfo
            transactionType={transactionType}
            createdAt={created_at}
            amount_stars={amount_stars}
            commission={commission}
          />

          <div className={styles.details}>
            <div className={styles.wrapper}>
              {Withdrawal?.type && (
                <TransactionDetail
                  iconName='withdrawal_type'
                  label={t('transaction_details.receiver')}
                  title={
                    Withdrawal?.type === 'TON'
                      ? t('transaction_details.withdrawal_type.ton')
                      : t('transaction_details.withdrawal_type.telegram')
                  }
                />
              )}

              {ToUser && (
                <TransactionDetail
                  iconName='recipient'
                  label={t('transaction_details.receiver')}
                  title={`${ToUser.username ? '@' + ToUser.username : ToUser.first_name + ' ' + ToUser.last_name}, ${ToUser.id}`}
                />
              )}

              {FromUser && (
                <TransactionDetail
                  iconName='recipient'
                  label={t('transaction_details.receiver')}
                  title={`${FromUser.username ? '@' + FromUser.username : FromUser.first_name + ' ' + FromUser.last_name}, ${FromUser.id}`}
                />
              )}

              <TransactionDetail
                iconName='transaction_status'
                label={t('transaction_details.status.text')}
                title={t(
                  Withdrawal?.status === 'PENDING'
                    ? 'transaction_details.status.processing'
                    : 'transaction_details.status.completed',
                )}
              />
            </div>
          </div>
        </div>
      </main>
    </>
  )
}

export default TransactionPage
